.backdrop {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(var(--space-4), env(safe-area-inset-top)) var(--space-4) max(var(--space-4), env(safe-area-inset-bottom));
  background: var(--color-overlay);
  animation: fadeIn 0.12s ease-out;
}

.backdropSheet {
  align-items: flex-end;
  padding: 0;
}

.panel {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  background: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-lg);
  outline: none;
}

.modal {
  width: 100%;
  max-height: min(860px, calc(100dvh - 2 * var(--space-6)));
  border-radius: var(--radius-lg);
  animation: popIn 0.14s ease-out;
}
.sm { max-width: 420px; }
.md { max-width: 560px; }
.lg { max-width: 860px; }

.sheet {
  width: 100%;
  max-height: calc(100dvh - max(24px, env(safe-area-inset-top)));
  border-radius: var(--radius-lg) var(--radius-lg) 0 0;
  padding-bottom: env(safe-area-inset-bottom);
  animation: slideUp 0.18s ease-out;
}

.grabber {
  width: 40px;
  height: 4px;
  margin: 8px auto 0;
  border-radius: var(--radius-pill);
  background: var(--color-border-strong);
  flex: none;
}

.header {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  padding: var(--space-4) var(--space-4) var(--space-3) var(--space-5);
  flex: none;
}
.sheet .header { padding-left: var(--space-4); }

.headings { flex: 1 1 auto; min-width: 0; padding-top: 4px; }
.title { font-size: var(--text-xl); overflow-wrap: anywhere; }
/* Phones: long titles (task names) must not take half of the sheet. */
.sheet .title { font-size: var(--text-lg); }
.description { margin-top: var(--space-1); color: var(--color-text-muted); font-size: var(--text-md); }
.close { margin: -4px -4px 0 0; flex: none; }

.body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
  padding: 0 var(--space-5) var(--space-4);
}
.sheet .body { padding: 0 var(--space-4) var(--space-4); }

.footer {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-5);
  border-top: 1px solid var(--color-border);
  flex: none;
}
.sheet .footer { padding: var(--space-3) var(--space-4); }
.sheet .footer > :global(.btn) { flex: 1 1 0; }

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes popIn { from { opacity: 0; transform: translateY(8px) scale(0.98); } to { opacity: 1; transform: none; } }
@keyframes slideUp { from { transform: translateY(100%); } to { transform: none; } }
